const endpoints = Object.freeze({
  class: {
    list: '/api/admin/class',
    create: '/api/admin/class/create',
    update: '/api/admin/class/update',
    delete: '/api/admin/class/',
  },
  division: {
    list: '/api/admin/divisions',
    create: '/api/admin/divisions/create',
    update: '/api/admin/divisions/update',
    delete: '/api/admin/divisions/',
  },
  shift: {
    list: '/api/admin/shift',
    create: '/api/admin/shift/create',
    update: '/api/admin/shift/update',
    delete: '/api/admin/shift/',
  },
  school: {
    list: '/api/admin/school',    
  },
  holidays: {
    list: '/api/admin/holidays',
    create: '/api/admin/holidays/create',
    update: '/api/admin/holidays/update',
    delete: '/api/admin/holidays/',
  },
  events: {
    list: '/api/admin/events',
    create: '/api/admin/events/create',
    update: '/api/admin/events/update',
    delete: '/api/admin/events/',
  },
  bus: {
    list: '/api/admin/bus',
    create: '/api/admin/bus/create',
    update: '/api/admin/bus/update',
    delete: '/api/admin/bus/',
    addGPS: '/api/admin/bus/gps/',
    getGPS: '/api/admin/bus/gps/',
    addPIR: '/api/admin/bus/pir',
    getPIR: '/api/admin/bus/pir/',
    addNFC: '/api/admin/bus/bus_admin_nfc_create',
    getNFC: '/api/admin/bus/bus_admin_nfc_read',
  },
  busBrand: {
    list: '/api/admin/bus_type',
    getById: '/api/admin/bus_type/',
    create: '/api/admin/bus_type/create',
    update: '/api/admin/bus_type/update',
    delete: '/api/admin/bus_type/delete/',
  },
  busLocation: {
    list: '/api/admin/daily_trip',
  },
  conductor: {
    list: '/api/admin/conductor',
    getById: '/api/admin/conductor/',
    create: '/api/admin/conductor/create',
    update: '/api/admin/conductor/update',
    delete: '/api/admin/conductor/delete/',
  },
  security: {
    list: '/api/admin/security',
    getById: '/api/admin/security/',
    create: '/api/admin/security/create',
    update: '/api/admin/security/update',
    delete: '/api/admin/security/delete/',
  },
  teamLeader: {
    list: '/api/admin/teamleader',
    getById: '/api/admin/teamleader/',
    create: '/api/admin/teamleader/create',
    update: '/api/admin/teamleader/update',
    delete: '/api/admin/teamleader/delete/',
  },
  transportAdmin: {
    list: '/api/admin/transport_list',
    getById: '/api/admin/transport/',
    create: '/api/admin/transport/create',
    update: '/api/admin/transport/update',
    delete: '/api/admin/transport/delete/',
  },
  driver: {
    list: '/api/admin/driver_list',
    create: '/api/admin/driver/create',
    update: '/api/admin/driver/update',
    delete: '/api/admin/driver/',
    bulkUpload: '/api/admin/driver/upload',
  },
  staff: {
    list: '/api/admin/staff_list',
    create: '/api/admin/staff/create',
    update: '/api/admin/staff/update',
    delete: '/api/admin/staff/',
    //bulkUpload: '/api/admin/driver/upload',
  },
  student: {
    list: '/api/admin/student',
    getById: '/api/admin/student/',
    create: '/api/admin/student/create',
    update: '/api/admin/student/update',
    delete: '/api/admin/student/',
    studentTrip: '/api/admin/student_trip/',
    studentDailyTrip: '/api/admin/daily_trip_student/',
    studentTripMutate: '/api/admin/trip/change_student_trip',
    studentGuardian: '/api/admin/student_parent/',
    studentEnrollment: '/api/admin/enrollment/upload',
    studentBulkUpload: '/api/admin/student/upload',
  },
  guardian: {
    list: '/api/admin/parent/list',
    getById: '/api/admin/parent/',
    linkToStudent: '/api/admin/parent/link_student/',
    unlinkFromStudent: '/api/admin/parent/link_student/delete',
    linkedStudents: '/api/admin/parent/student_list/',
    removeFromStudent: '/api/admin/parent/link_student/delete',
    create: '/api/admin/parent/create',
    update: '/api/admin/parent/update',
    delete: '/api/admin/parent/delete/',
    setPrimary: '/api/admin/student_parent/set_primary',
  },
  trip: {
    list: '/api/admin/trip_list',
    create: '/api/admin/trip/create',
    update: '/api/admin/trip/update',
    delete: '/api/admin/trip/',
    activeList: '/api/admin/trip/active_trips',
    studentTripList: '/api/admin/student_trip/list/',
    studentsInTrip: '/api/admin/default_trip_student/',
    addStudentToTrip: '/api/admin/trip/trip_student/add',
    removeStudentFromTrip: '/api/admin/trip/trip_student/remove',
  },
   stay: {
    list: '/api/admin/trip_list',
    create: '/api/admin/trip/create',
    update: '/api/admin/trip/update',
    delete: '/api/admin/trip/',
    activeList: '/api/admin/trip/active_trips',
    studentTripList: '/api/admin/student_trip/list/',
    studentsInTrip: '/api/admin/default_trip_student/',
    addStudentToTrip: '/api/admin/trip/trip_student/add',
    removeStudentFromTrip: '/api/admin/trip/trip_student/remove',
  },
  tripNumber: {
    list: '/api/admin/trip_number',
    getById: '/api/admin/trip_number/',
    create: '/api/admin/trip_number/create',
    update: '/api/admin/trip_number/update',
    delete: '/api/admin/trip_number/delete/',
  },
  nfc: {
    getUserNFC: '/api/admin/common/get_nfc',
    createUserNFC: '/api/admin/common/nfc_create',
    bulkUpload: '/api/admin/nfc/upload',
  },
  fileUpload: {
    upload: '/api/config/common/upload',
  },
  roots: {
    list: '/api/admin/routes',
    create: '/api/admin/routes/create',
    update: '/api/admin/routes/update',
    delete: '/api/admin/routes/',
  },
  profile: {
    schoolDetails: '/api/admin/school',
    schoolDetailUpdate: '/api/admin/school/update',
  },
  subSchool: {
    list: '/api/admin/master/sub-schools/list',
  },
  parentMessages: {
    list: '/api/admin/parentmessage/list',
    create: '/api/admin/parentmessage/create',
    delete: '/api/admin/parentmessage/delete/',
  },
  reports: {
    inspectionReport: '/api/admin/inspection_report',
    fleetReport: '/api/admin/fleet_report',
    studentAttendanceReport: '/api/admin/student_attendence_report',
    driverLicenseStatusReport: '/api/admin/driver_license_status_report',
    routeReport: '/api/admin/route_report',
    driverLoginReport: '/api/admin/driver_login_report',
    vehiclemovementReport: '/api/admin/vehicle_movement_report',
    tripNotStartedReport: '/api/admin/trip_not_started_report',
  },
    banner: {
    list: '/api/admin/banner_list',    
    create: '/api/admin/banner/create',
    update: '/api/admin/banner/update',
    delete: '/api/admin/banner/',
  },
  sync: {
  config: '/api/admin/get_sync_data',     // GET → to check sync_data
  trigger: '/api/admin/sync_data'      // get → to run sync
}
})
export default endpoints
